import './rich-text.scss'

import { RichTextInterface } from '../../cmsTypes'

export const RichTextExtension: React.FC<RichTextInterface> = props => {
    return (
        <div
            className={props.classOverride ?? 'rich-extension'}
            dangerouslySetInnerHTML={{ __html: props.htmlText }}
        ></div>
    )
}
